import {GameJackpotValueDefaultBox} from "./game-jackpot-value.default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {GameJackpotValueSIBox} from "./game-jackpot-value.si.box";
import {GameJackpotValueMrGreenBox} from "./game-jackpot-value.mrgreen.box";
import { GameJackpotValueSICisBox } from "./game-jackpot-value.siCis.box";

export const GameJackpotValueBox = styledByTheme(GameJackpotValueDefaultBox)
    .forSI(GameJackpotValueSIBox)
    .forSICis(GameJackpotValueSICisBox)
    .forMrGreen(GameJackpotValueMrGreenBox)
    .apply();